export function getOne(content, id) {
  return content[id];
}
